import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { attemptDeliverGlsInitializeUrl } from '@/game-client/gls-pending-initialize-url';
import { useStore } from '@/store/useStore';

/**
 * Delivers GL/INITIALIZE_URL when payload and client readiness land in either order.
 */
const useGlsInitializeUrlDelivery = () => {
  const {
    glsInitializeUrl,
    handshakeLaunchEpoch,
    clientLoaded,
    jackpotReconcileRunning,
  } = useStore(
    useShallow((s) => ({
      glsInitializeUrl: s.gamePayload.glsInitializeUrl,
      handshakeLaunchEpoch: s.gamePayload.handshakeLaunchEpoch,
      clientLoaded: s.clientStatus.loaded,
      jackpotReconcileRunning: s.gameStatus.jackpotReconcileRunning,
    })),
  );

  useEffect(() => {
    attemptDeliverGlsInitializeUrl();
  }, [
    glsInitializeUrl,
    handshakeLaunchEpoch,
    clientLoaded,
    jackpotReconcileRunning,
  ]);
};

export default useGlsInitializeUrlDelivery;
